import React from "react";
import { BiPlayCircle } from "react-icons/bi";

const HeroSection = () => {
  return (
    <section id="hero" className="d-flex align-items-center">
      <div className="container" data-aos="zoom-out" data-aos-delay="100">
        <h1>
          Bienvenido a <span>MatchGame</span>
        </h1>
        <h2>El lugar donde organizar torneos es más fácil</h2>
        <div className="d-flex">
          <a href="/signup" className="btn-get-started scrollto">
            Empieza a usarlo
          </a>
          <a
            // href="https://www.youtube.com/watch?v=jDDaplaOz7Q"
            className="glightbox btn-watch-video"
          >
            <BiPlayCircle />
            <span> Mirar video</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
